﻿

$(document).ready(function () {
    var priceGrainResellerOverviewPage = new PriceGrainResellerOverviewPage();
    priceGrainResellerOverviewPage.init();
    $(document).on("change", "select", function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option
                .attr("selected", true).siblings()
                .removeAttr("selected");
        }

    });
    // enhance table saw to make responsive table
    $(document).trigger("enhance.tablesaw");
});

var  renderPriceGrainResellerOverviewTable = function(title, data) {
    var printWindow = window.open("", "_blank");
    printWindow.document.write('<html><head><title>' + title + '</title>');
    printWindow.document.write("<link rel=\"stylesheet\" href=\"/Static/dist/styles/styles.css\" type=\"text/css\" media=\"all\"/>");
    printWindow.document.write("<style type=\"text/css\">");
    printWindow.document.write("button.my-agreements__collapse-control:not(.is-active) {display: none !important;}");
    printWindow.document.write("button.my-agreements__collapse-control.is-active {padding-bottom: 0px !important;}");
    printWindow.document.write(".ResellerOverviewUnloadingPanel {display: block !important;overflow: visible !important;height:auto !important;max-height: none !important;right: inherit;width:100% !important;}");
    printWindow.document.write(".collapse__target.is-active { display: block;padding-top: 0px !important;padding-right: 0px !important;padding-left: 0px !important;}");
    printWindow.document.write(".ResellerOverviewTerminrubrik:last-child { display: none !important;}");
    printWindow.document.write("table.tblPriceGrainResellerOverviewResults tr:not(.price-grain-reseller-overview-favorite-row){display: none !important;}");
    printWindow.document.write("button.js-toggle:not(.expand-price-grain-reseller-overview-row) {display: none !important;}");
    printWindow.document.write("#priceAreaNameResellerOverview {display: inline-block !important;margin-top: 10px !important;margin-bottom: 10px !important;}");
    printWindow.document.write('</style></head><body>');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    setTimeout(function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }, 3000);
    return true;
}

var printPriceGrainResellerOverviewTable = function(priceAreaHeader,priceGrainResellerOverviewHeader) {
    var btn = $('#printPriceGrainResellerOverviewBtn');
    var priceAreaHeader = btn.attr('data-priceAreaHeader');
    var overviewHeader = btn.attr('data-overviewHeader');
    var priceArea = $('#price-grain-reseller-overview-areas-list li.selected').data('name');
    $("#priceAreaNameResellerOverview > h4").html(priceAreaHeader+": "+ priceArea);
    var title = overviewHeader + ' - ' + priceArea;
    renderPriceGrainResellerOverviewTable(title, $('<div/>').append($("#printable-price-grain-reseller-overview-table").clone()).html());
}

var PriceGrainResellerOverviewFunction = PriceGrainResellerOverviewFunction || (function () {
    var blockUI = function () {
        $("#price-grain-reseller-overview-loader").show();
    };
    var unBlockUI = function () {
        $("#price-grain-reseller-overview-loader").hide();
    };

    var disableButtons = function () {
        $("#printPriceGrainResellerOverviewBtn").addClass("disabled-btn");
    };
    var enableButtons = function () {
        $("#printPriceGrainResellerOverviewBtn").removeClass("disabled-btn");
    };

    return {
        blockUI: blockUI,
        unBlockUI: unBlockUI,
        enableButtons: enableButtons,
        disableButtons: disableButtons
    };
})();

var PriceGrainResellerOverviewPage = function () {
    var hidePriceGrainResellerOverview = function () {
        $('.js-show-hide-price-grain-reseller-overview-result').hide();
    };

    var showPriceGrainResellerOverview = function () {
        $('.js-show-hide-price-grain-reseller-overview-result').show();
    };

    var getCurrentlySelectedPriceAreaId = function () {
        return $('#price-grain-reseller-overview-areas-list').attr('data-value');
    };
    var setPriceGrainResellerOverview = function () {
        $('button.js-toggle').each(function (i, priceGrainResellerOverviewRow) {
            var control = $(priceGrainResellerOverviewRow);
            if (control.hasClass('expand-price-grain-reseller-overview-row')) {
                farmday.modules.toggle.show(control);
            }
        });
    };
    var requests = [];
    var fetchPriceGrainResellerOverview = function () {
        hidePriceGrainResellerOverview();
        PriceGrainResellerOverviewFunction.disableButtons();
        PriceGrainResellerOverviewFunction.blockUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        var tableResult = $("#price-grain-reseller-overview-result");
        requests = [];
        var priceGrainResellerOverviewDefered = $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-overview/GetPriceGrainResellerOverview",
            async: true,
            cache: false,
            data: JSON.stringify({ priceAreaId: getCurrentlySelectedPriceAreaId() }),
            contentType: "application/json; charset=utf-8",
            dataType: "html",
            success: function (priceGrainResellerOverviewResult) {
                if (priceGrainResellerOverviewResult && priceGrainResellerOverviewResult.length > 0) {
                    tableResult.html(priceGrainResellerOverviewResult);
                    /* little fade in effect */
                    tableResult.fadeIn('fast');
                }
                else {
                    tableResult.html("<div>Det finns inga priser för valt område och datum.</div>");
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching price grain reseller overview!" + "</br>" + exception);
                tableResult.html("<h2>Det gick inte att hämta återförsäljare spannmålspriser</h2>");

            }
        });

        requests.push(priceGrainResellerOverviewDefered);
        $.when.apply($, requests).then(function () {
            PriceGrainResellerOverviewFunction.unBlockUI();
            PriceGrainResellerOverviewFunction.enableButtons();
            setPriceGrainResellerOverview();
            showPriceGrainResellerOverview();
        });
    };
    var addOnClickEvents = function () {
        $('#price-grain-reseller-overview-areas-list .dropdown li a').on("click", function (e) {
            fetchPriceGrainResellerOverview();
        });

        $('#printPriceGrainResellerOverviewBtn').on("click", function (e) {
            printPriceGrainResellerOverviewTable();
        });

    };
    var addPriceGrainResellerOverviewFavorite = function (target, priceGrainResellerOverviewFavorite) {
        PriceGrainResellerOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-overview/AddPriceGrainResellerOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainResellerOverviewFavorite: priceGrainResellerOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.toggleClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.addClass('price-grain-reseller-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var tblResult = $('#tblPriceGrainResellerOverviewResults_' + target.data('pricegroupid'));
                    //add expand row if there is any favorite
                    if (parentRow && !parentRow.hasClass('expand-price-grain-reseller-overview-row')) {
                        parentRow.addClass('expand-price-grain-reseller-overview-row');
                    }
                    //add active icon to select all if all rows are favorite
                    if (parentRow && tblResult.find('tr.price-grain-reseller-overview-favorite-row').length == tblResult.find('tr').length) {
                        parentRow.find('button.js-price-grain-reseller-overview-favorite-all').addClass("active");
                    }
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tilläggning av återförsäljare prislista översikt favorit.");
            },
            complete: function () {
                PriceGrainResellerOverviewFunction.unBlockUI();
            }
        });
    }
    var removePriceGrainResellerOverviewFavorite = function (target, priceGrainResellerOverviewFavorite) {
        PriceGrainResellerOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-reseller-overview/RemovePriceGrainResellerOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainResellerOverviewFavorite: priceGrainResellerOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.toggleClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.removeClass('price-grain-reseller-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var hasFavoriteRows = $('#tblPriceGrainResellerOverviewResults_' + target.data('pricegroupid')).find('tr.price-grain-reseller-overview-favorite-row').length > 0;
                    if (!hasFavoriteRows && parentRow.hasClass('expand-price-grain-reseller-overview-row')) {
                        parentRow.removeClass('expand-price-grain-reseller-overview-row');
                    }
                    //remove active class from select all
                    parentRow.find('button.js-price-grain-reseller-overview-favorite-all').removeClass("active");
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tabort av återförsäljare prislista översikt favorit.");
            },
            complete: function () {
                PriceGrainResellerOverviewFunction.unBlockUI();
            }
        });
    }
    var priceGrainResellerOverviewFavoriteClickEvent = function () {
        $(document).on("click", ".js-price-grain-reseller-overview-favorite", function (e) {
            e.stopPropagation();
            var priceGrainResellerOverviewFavorite = {
                PriceAreaId: getCurrentlySelectedPriceAreaId(),
                PriceGroupId: $(this).data("pricegroupid"),
                ItemNumber: $(this).data("itemnumber"),
                Sort: $(this).data("sort")
            }
            if ($(this).hasClass("active")) {
                removePriceGrainResellerOverviewFavorite($(this), priceGrainResellerOverviewFavorite);
            } else {
                addPriceGrainResellerOverviewFavorite($(this), priceGrainResellerOverviewFavorite);
            }

        });

    }
    var addAllPriceGrainResellerOverviewFavorites = function (target) {
        var priceGrainResellerOverviewFavoritesToAdd = [];
        var controls = [];
        PriceGrainResellerOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainResellerOverviewResults_' + target.data('pricegrainreselleroverviewrowid')).find('tr:not(.price-grain-reseller-overview-favorite-row)').each(function (i, priceGrainResellerOverviewRow) {
            var control = $(priceGrainResellerOverviewRow).find('button.js-price-grain-reseller-overview-favorite');
            var priceGrainResellerOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainResellerOverviewFavoritesToAdd.push(priceGrainResellerOverviewFavorite);
        });
        if (priceGrainResellerOverviewFavoritesToAdd.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-reseller-overview/AddAllPriceGrainResellerOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainResellerOverviewFavorites: priceGrainResellerOverviewFavoritesToAdd }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.addClass("active");
                        //adding active class and marking all child rows as favorite
                        for (var index = 0; index < controls.length; index++) {
                            controls[index].addClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.addClass('price-grain-reseller-overview-favorite-row');
                        }
                        //add expand row and open the child row container
                        var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegrainreselleroverviewrowid') + ']');
                        if (parentRow && !parentRow.hasClass('expand-price-grain-reseller-overview-row')) {
                            parentRow.addClass('expand-price-grain-reseller-overview-row');
                            farmday.modules.toggle.show(parentRow);
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av återförsäljare prislista översikt favorit.");
                },
                complete: function () {
                    PriceGrainResellerOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var removeAllPriceGrainResellerOverviewFavorites = function (target) {
        var priceGrainResellerOverviewFavoritesToRemove = [];
        var controls = [];
        PriceGrainResellerOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainResellerOverviewResults_' + target.data('pricegrainreselleroverviewrowid')).find('tr.price-grain-reseller-overview-favorite-row').each(function (i, priceGrainResellerOverviewRow) {
            var control = $(priceGrainResellerOverviewRow).find('button.js-price-grain-reseller-overview-favorite');
            var priceGrainResellerOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainResellerOverviewFavoritesToRemove.push(priceGrainResellerOverviewFavorite);
        });
        if (priceGrainResellerOverviewFavoritesToRemove.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-reseller-overview/RemoveAllPriceGrainResellerOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainResellerOverviewFavorites: priceGrainResellerOverviewFavoritesToRemove }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.removeClass("active");

                        for (var index = 0; index < controls.length; index++) {
                            controls[index].removeClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.removeClass('price-grain-reseller-overview-favorite-row');
                        }
                        var tblResult = $('#tblPriceGrainResellerOverviewResults_' + target.data('pricegrainreselleroverviewrowid'));
                        //if there are no more favorite rows then remove the expand row class
                        var hasFavoriteRows = tblResult.find('tr.price-grain-reseller-overview-favorite-row').length > 0;
                        if (!hasFavoriteRows && target.hasClass('expand-price-grain-reseller-overview-row')) {
                            target.removeClass('expand-price-grain-reseller-overview-row');
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av återförsäljare prislista översikt favorit.");
                },
                complete: function () {
                    PriceGrainResellerOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var priceGrainResellerOverviewFavoriteAllClickEvent = function () {
        $(document).on("click", ".js-price-grain-reseller-overview-favorite-all", function (e) {
            e.stopPropagation();
            if ($(this).hasClass("active")) {
                removeAllPriceGrainResellerOverviewFavorites($(this));
            } else {
                addAllPriceGrainResellerOverviewFavorites($(this));
            }
        });
    }
    var init = function () {
        addOnClickEvents();
        priceGrainResellerOverviewFavoriteClickEvent();
        priceGrainResellerOverviewFavoriteAllClickEvent();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        if (priceAreaId && priceAreaId.length > 0) {
            fetchPriceGrainResellerOverview();
        }
    };
    return {
        init: init
    };
};